import { Injectable } from '@angular/core'
import { environment } from '@candidate/environments/environment'
import { isNotNil } from '@engineering11/utility'
import { RestApiClient } from '@engineering11/web-api-rest'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { DEFAULT_NETWORK_MONITORING_CONFIG, getBaseSuffix, ICandidateJobVM, TokenStorage } from 'shared-lib'
import { CandidateApplicationStageService } from '../candidate-application/candidate-application-stage.service'
import { CandidateJobVMRepository } from './candidate-job-vm.repository'

const filterFulfilledForJob = (job: ICandidateJobVM) => {
  return { ...job }
}

@Injectable({
  providedIn: 'root',
})
export class MyJobService {
  private restApiClient: RestApiClient
  constructor(
    tokenStorage: TokenStorage,
    private candidateJobVMRepository: CandidateJobVMRepository,
    private candidateApplicationStageService: CandidateApplicationStageService
  ) {
    this.restApiClient = new RestApiClient({
      baseUrl: environment.services.candidate,
      token: () => tokenStorage.getAccessToken(),
      baseSuffix: getBaseSuffix(environment, 'candidate'),
      ...DEFAULT_NETWORK_MONITORING_CONFIG,
    })
  }

  getMyJobs(userId: string): Observable<ICandidateJobVM[]> {
    return this.candidateJobVMRepository.getAllForUser(userId).pipe(map(candidateJobs => candidateJobs.map(filterFulfilledForJob)))
  }

  getMyJobsValueChanges(userId: string): Observable<ICandidateJobVM[]> {
    return this.candidateJobVMRepository.getAllForUserValueChanges(userId).pipe(map(candidateJobs => candidateJobs.map(filterFulfilledForJob)))
  }

  getJobValueChanges(userId: string, jobPostId: string) {
    const id = this.buildID({ userId, jobId: jobPostId })
    return this.candidateJobVMRepository.getValueChanges(id).pipe(filter(isNotNil), map(filterFulfilledForJob))
  }

  getJob(jobPostId: string): Observable<ICandidateJobVM> {
    return this.restApiClient.get<ICandidateJobVM>(`candidate-jobs/${jobPostId}`).pipe(map(item => filterFulfilledForJob(item.data)))
  }

  addToMyJob(data: { jobId: string }): Observable<any> {
    return this.restApiClient.put<any>('candidate-jobs', data).pipe(map(item => item))
  }

  async removeJob(userId: string, jobPostId: string) {
    // TODO: Bring to backend after testing
    const id = this.buildID({ userId, jobId: jobPostId })
    const deleteJobPromise = this.candidateJobVMRepository.delete(id)
    const deleteStagePromise = this.candidateApplicationStageService.deleteByUserAndJob(userId, jobPostId)
    await Promise.all([deleteJobPromise, deleteStagePromise])
    return id
  }

  private buildID(model: Pick<ICandidateJobVM, 'userId' | 'jobId'>) {
    return `${model.userId}_${model.jobId}`
  }
}
